
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-50 via-white to-cyan-50" style={{
      backgroundImage: 'url(https://public.readdy.ai/ai/img_res/783719a442436ea409e1ed54eaba11cb.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/80 to-transparent"></div>
      
      <div className="relative max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-block px-4 py-2 bg-blue-100 rounded-full">
              <span className="text-blue-600 font-semibold text-sm">Secure VPN Solution</span>
            </div>
            
            <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Your Privacy,
              <br />
              <span className="bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
                Our Priority
              </span>
            </h2>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              Experience ultimate online security and privacy with ECOMODE STUDIO's advanced VPN technology. Browse anonymously, access content freely, and protect your digital footprint with military-grade encryption.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <button onClick={scrollToContact} className="bg-gradient-to-r from-blue-600 to-cyan-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-xl transition-all cursor-pointer whitespace-nowrap">
                Start Free Trial
              </button>
              <button onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })} className="bg-white text-gray-700 px-8 py-4 rounded-full text-lg font-semibold border-2 border-gray-200 hover:border-blue-600 hover:text-blue-600 transition-all cursor-pointer whitespace-nowrap">
                Learn More
              </button>
            </div>
            
            <div className="flex items-center gap-8 pt-4">
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-fill text-green-500 text-2xl"></i>
                <span className="text-gray-700 font-medium">256-bit Encryption</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-global-line text-blue-500 text-2xl"></i>
                <span className="text-gray-700 font-medium">Global Servers</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-speed-line text-cyan-500 text-2xl"></i>
                <span className="text-gray-700 font-medium">Ultra Fast</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
